// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"06c9bc3a","381":"9c8d835d"}[chunkId] + ".chunk.js";
};